import { cn } from '@/utils/commonUtil'
import { createIcon } from '@/utils/factoryUtil/createIcon'

import styles from './SVGCommonSpinner.module.scss'

export const SVGCommonSpinner = createIcon('SVGCommonSpinner', ({ className, ...props }) => (
  <svg className={cn(styles.container, className)} viewBox='0 0 100 100' {...props}>
    <path d='M50,99c-5.52,0-10-4.48-10-10s4.48-10,10-10c15.99,0,29-13.01,29-29s-13.01-29-29-29-29,13.01-29,29c0,5.52-4.48,10-10,10S1,55.52,1,50C1,22.98,22.98,1,50,1s49,21.98,49,49-21.98,49-49,49Z' />
  </svg>
))
